// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './styles/GlobalStyle.jsx';
import theme from './styles/Theme.jsx';
import { ModalProvider } from './contexts/ModalContext.jsx';
import { HelmetProvider, Helmet } from 'react-helmet-async';

// Pages
import HomePage from './pages/HomePage';
import JavaPage from './pages/JavaPage';
import JavaAdvancedPage from './pages/JavaAdvancedPage';
import CPage from './pages/CPage';
import ReactPage from './pages/ReactPage';
import DatabasePage from './pages/DatabasePage';
import TypeScriptPage from './pages/TypeScriptPage';
import AiCodingPage from './pages/AiCodingPage';
import AboutPage from './pages/AboutPage';
import InstructorsPage from './pages/InstructorsPage';
import ReviewsPage from './pages/ReviewsPage';
import BlogPage from './pages/BlogPage';
import FaqPage from './pages/FaqPage';
import LearningGuidePage from './pages/LearningGuidePage';
import TuitionPage from './pages/TuitionPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';

// Components
import Header from './components/common/Header';
import Footer from './components/common/Footer';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  name: 'ElectroWave Club',
  alternateName: '일렉트로웨이브 클럽',
  url: 'https://electrowave.kr',
  logo: 'https://electrowave.kr/assets/electrowave-logo.svg',
  description:
    'ElectroWave Club은 1:1 멘토 매칭 기반의 코딩 스터디 클럽입니다. Java, React, AI 코딩 등 실무 중심 커리큘럼을 줌(Zoom)으로 진행합니다.',
  sameAs: [],
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'firstman9@protonmail.com',
    contactType: 'customer support',
    availableLanguage: ['Korean'],
  },
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'ElectroWave Club',
  url: 'https://electrowave.kr',
  inLanguage: 'ko-KR',
};

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <html lang="ko" />
        <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      </Helmet>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <ModalProvider>
          <Router>
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/java" element={<JavaPage />} />
              <Route path="/java-advanced" element={<JavaAdvancedPage />} />
              <Route path="/c" element={<CPage />} />
              <Route path="/react" element={<ReactPage />} />
              <Route path="/database" element={<DatabasePage />} />
              <Route path="/typescript" element={<TypeScriptPage />} />
              <Route path="/ai-coding" element={<AiCodingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/instructors" element={<InstructorsPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/learning-guide" element={<LearningGuidePage />} />
              <Route path="/tuition" element={<TuitionPage />} />
              <Route path="/refund-policy" element={<RefundPolicyPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
            </Routes>
            <Footer />
          </Router>
        </ModalProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
